<template>
    <div class="bg-white shadow sm:rounded-lg">
        <div class="px-4 py-5 sm:p-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">Finn setninger på tegnspråk</h3>
            <div class="mt-2 max-w-xl text-sm text-gray-500">
                <p>Skriv inn en setning i tekstfeltet og se hvordan et uttales på tegnspråk. Separer ordene med mellomrom. Med ord som hører sammen kan man forsøke å skrive f.eks. "110m-hekk."</p>
            </div>
            <form class="mt-5 sm:flex sm:items-center">
                <div class="w-full sm:max-w-xs">
                    <label for="text" class="sr-only">Setning</label>
                    <div class="relative">
                        <input type="text" v-model="value_" name="text" id="email" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" :placeholder="examples[0]">
                        <transition name="template" enter-active-class="ease-out duration-200" enter-from-class="opacity-0" enter-to-class="opacity-100" leave-active-class="ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
                            <div v-if="text.length" @click="text = ''" class="absolute inset-y-0 right-0 pr-3 pl-2 flex items-center cursor-pointer">
                                <i class="text-gray-400 fa-solid fa-circle-xmark"></i>
                            </div>
                        </transition>
                    </div>
                </div>

                <a :href="link_" target="_blank" v-if="this.text.length" class="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">Lag side som kan deles</a>

                <!-- <button type="submit" class="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">Finn tegn</button> -->
            </form>
            <ul class="mt-3 -mx-1 max-w-xl">
                <li v-for="example in examples" @click="value_ = example" class="p-1 inline-block">
                    <span class="px-2 py-1 transition-colors cursor-pointer bg-blue-200 hover:bg-blue-300 text-sm inline-block rounded">{{ example }}</span>
                </li>
            </ul>
        </div>
    </div>

</template>

<script>
import Debouncer from '../Classes/Utils/Debouncer';

export default {
    data() {
        return {
            text: '',
            debouncer: new Debouncer,
            examples: [
                'Velkommen til tegnordboken',
                'Hva heter du',
                'Hvor bor du',
                'Spiller du fotball',
                'Skal vi spille',
                'Hvor mange år er du',
            ],
        }
    },

    computed: {
        value_: {
            get() {
                return this.text;
            },
            set(value) {
                this.text = value;

                this.debouncer.handle(() => {
                    this.$emit('handle', value.trim().replace(/ +/, ' ').toLowerCase().split(' '));
                })
            },
        },
        link_() {
            var getUrl = window.location;
            var baseUrl = getUrl .protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];


            return baseUrl + '?ord=' + this.text.toLowerCase();
        },
    },
}
</script>
